import { Controller } from "@hotwired/stimulus";

// Carrousel des pages d'une version de media template : une carte multipage
// (MediaTemplate::Version::PAGE_DELIMITER) produit un média par page, on les feuillette ici.
// Même parti pris que media_template_versions_controller : les pages inactives sont rendues
// transparentes, jamais masquées, pour que content-media--html-preview puisse les mesurer et
// les mettre à l'échelle dès le chargement (un conteneur masqué a des dimensions nulles).
export default class extends Controller {
  static targets = ["page", "dot"];

  select(event) {
    this.show(this.dotTargets.indexOf(event.currentTarget));
  }

  previous(event) {
    event.preventDefault();
    this.show((this.currentIndex - 1 + this.pageTargets.length) % this.pageTargets.length);
  }

  next(event) {
    event.preventDefault();
    this.show((this.currentIndex + 1) % this.pageTargets.length);
  }

  show(index) {
    if (index < 0) return;

    this.dotTargets.forEach((dot, i) => dot.toggleAttribute("data-active", i === index));
    this.pageTargets.forEach((page, i) => {
      page.classList.toggle("opacity-0", i !== index);
      page.classList.toggle("pointer-events-none", i !== index);
    });
  }

  get currentIndex() {
    const index = this.pageTargets.findIndex((page) => !page.classList.contains("opacity-0"));
    return index === -1 ? 0 : index;
  }
}
